import React, { useState, useEffect } from 'react';
import { API } from '../config';

export default function RequestsList({ currentUser, onRefresh }) {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  function load() {
    if (!currentUser) return;
    fetch(`${API.apiBase}/api/connect-requests?userId=${currentUser.id}`)
      .then(r => r.json())
      .then(data => {
        setRequests(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }

  useEffect(() => { load(); }, [currentUser]);

  async function handleApprove(id) {
    try {
      const r = await fetch(`${API.apiBase}/api/connect-requests/${id}/approve`, { method: 'POST' });
      if (r.ok) {
        if (onRefresh) onRefresh();
        load();
      }
    } catch {}
  }

  async function handleReject(id) {
    try {
      const r = await fetch(`${API.apiBase}/api/connect-requests/${id}/reject`, { method: 'POST' });
      if (r.ok) load();
    } catch {}
  }

  if (loading) return <div style={{ padding: 20, textAlign: 'center', color: '#999' }}>加载中...</div>;

  const pending = requests.filter(r => r.status === 'pending');
  const approved = requests.filter(r => r.status === 'approved');

  if (requests.length === 0) return (
    <div style={{ padding: 20, textAlign: 'center', color: '#999' }}>暂无联系请求</div>
  );

  return (
    <div>
      {pending.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#e91e63', marginBottom: 8 }}>待审批（{pending.length}）</div>
          {pending.map(r => (
            <div key={r.id} style={{ padding: 10, marginBottom: 6, border: '1px solid #ffcdd2', borderRadius: 8, background: '#fce4ec' }}>
              {r.isIncoming ? (
                <div>
                  <div style={{ fontSize: 14 }}><strong>{r.fromName}</strong> 想要联系你</div>
                  <div style={{ fontSize: 12, color: '#666' }}>{r.fromSchool} · {r.fromClass || ''}</div>
                  <div style={{ fontSize: 12, color: '#999' }}>关于：{r.needTitle}</div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                    <button onClick={() => handleApprove(r.id)} style={{ padding: '4px 16px', border: 'none', borderRadius: 4, background: '#2e7d32', color: '#fff', cursor: 'pointer', fontSize: 13 }}>通过 ✓</button>
                    <button onClick={() => handleReject(r.id)} style={{ padding: '4px 16px', border: '1px solid #ccc', borderRadius: 4, background: '#fff', color: '#666', cursor: 'pointer', fontSize: 13 }}>忽略</button>
                  </div>
                </div>
              ) : (
                <div style={{ color: '#888', fontSize: 13 }}>
                  已向 <strong>{r.otherName}</strong> 发送联系请求，等待对方通过
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {approved.length > 0 && (
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#2e7d32', marginBottom: 8 }}>已联系上（{approved.length}）</div>
          {approved.map(r => (
            <div key={r.id} style={{ padding: 10, marginBottom: 6, border: '1px solid #c8e6c9', borderRadius: 8, background: '#f1f8e9' }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#2e7d32', marginBottom: 4 }}>{r.needTitle}</div>
              <div style={{ fontSize: 13, lineHeight: 1.8 }}>
                <div><strong>{r.otherName}</strong></div>
                <div style={{ color: '#666' }}>{r.otherSchool} · {r.otherClass || ''}</div>
                <div style={{ color: '#e91e63', fontWeight: 500 }}>📞 {r.otherPhone || '未提供'}</div>
              </div>
              <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>{new Date(r.respondedAt || r.createdAt).toLocaleDateString()} 建立联系</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}